import React from "react";
import {
  MDBBtn,
  MDBInput,
  MDBIcon,
  MDBSpinner,
} from "mdb-react-ui-kit";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

import "./DemoAccessPrompt.css";

export class DemoAccessPrompt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      key: "",
      error: "",
      loading: false,
    };
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (!this.state.key.trim()) return;

    this.setState({ loading: true, error: "" });

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ app: this.props.appCode, key: this.state.key.trim() }),
    };

    try {
      const response = await doFetch("SSO", "validateDemoKeyPublic", requestOptions);
      const data = await response.json();

      if (data.STATE === "SUCCESS") {
        if (this.props.onAccessGranted) {
          this.props.onAccessGranted(data.DATA, this.state.key.trim());
        }
      } else {
        this.setState({ error: "Clave inválida o expirada", loading: false });
      }
    } catch (err) {
      this.setState({ error: "Error de conexión", loading: false });
    }
  }

  render() {
    const appTitle = this.props.appTitle || this.props.appCode;

    return (
      <div className="demo-access-prompt">
        <div className="demo-access-card">
          <div className="demo-access-icon">
            <MDBIcon fas icon="flask" size="3x" />
          </div>
          <h3>Modo Demo</h3>
          <p className="text-muted">
            <strong>{appTitle}</strong> está en modo demo.
            Introduce la clave de acceso para continuar.
          </p>
          <form onSubmit={(e) => this.handleSubmit(e)}>
            <MDBInput
              type="text"
              label="Clave de acceso"
              value={this.state.key}
              onChange={(e) => this.setState({ key: e.target.value, error: "" })}
              className="mb-3"
              autoFocus
            />
            {this.state.error && (
              <p className="text-danger mb-3" style={{ fontSize: "0.85rem" }}>
                <MDBIcon fas icon="exclamation-circle" className="me-1" />
                {this.state.error}
              </p>
            )}
            <MDBBtn type="submit" disabled={this.state.loading || !this.state.key.trim()} block>
              {this.state.loading ? (
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              ) : (
                <MDBIcon fas icon="unlock" className="me-2" />
              )}
              Acceder
            </MDBBtn>
          </form>
        </div>
      </div>
    );
  }
}
